module.exports = __webpack_public_path__ + "img/radio.4bf588da.svg";